<button
  class="single-info"
  [class]="value ? 'enabled' : 'disabled'"
  [cdkCopyToClipboard]="value ?? ''"
  (cdkCopyToClipboardCopied)="onClipboardCopy($event)"
>
  <div class="text-content">
    <p class="label-info">{{ labelPath | translate }}</p>
    <p class="value-info">
      {{ value || ("map-detail.infoPlaceholder" | translate) }}
    </p>
  </div>
  @if (icon && !displayCheck) {
    <div class="button-icon">
      @if (iconColor) {
        <svg-icon
          [name]="icon"
          [svgStyle]="{ fill: iconColor, 'height.px': 32, 'width.px': 32 }"
        ></svg-icon>
      }
      @if (!iconColor) {
        <svg-icon
          [name]="icon"
          [svgStyle]="{ fill: '#161616', 'height.px': 32, 'width.px': 32 }"
        ></svg-icon>
      }
    </div>
  }
  @if (!displayCheck && value) {
    <div class="copy-content">
      <svg-icon
        name="copy"
        [svgStyle]="{ fill: '#757575', 'height.px': 16, 'width.px': 16 }"
      ></svg-icon>
      <p>{{ "map-detail.copy" | translate }}</p>
    </div>
  }
  @if (displayCheck && value) {
    <div class="copied-content">
      <svg-icon
        name="check"
        [svgStyle]="{ fill: '#757575', 'height.px': 16, 'width.px': 16 }"
      ></svg-icon>
      <p>{{ "map-detail.copied" | translate }}</p>
    </div>
  }
</button>
